export const serviceIdMap = new Map();

export const ServiceIds = {}

const ServiceIdsTelkom = {
    free: "telkom-melody-madness-free",
    vipDaily: "telkom-melody-madness-daily",
    vipWeekly: "telkom-melody-madness-weekly",
    vipMonthly: "telkom-melody-madness-monthly"
}

serviceIdMap.set(ServiceIdsTelkom.free, 1);
serviceIdMap.set(ServiceIdsTelkom.vipDaily, 2);
serviceIdMap.set(ServiceIdsTelkom.vipWeekly, 3);
serviceIdMap.set(ServiceIdsTelkom.vipMonthly, 4);


export function setServiceIds() {
    serviceIdMap.set(ServiceIdsTelkom.free, 1);
    serviceIdMap.set(ServiceIdsTelkom.vipDaily, 2);
    serviceIdMap.set(ServiceIdsTelkom.vipWeekly, 2);
    serviceIdMap.set(ServiceIdsTelkom.vipMonthly, 2);
}

export function getNetwork(brand) {
    return 'Telkom'
}
